import { AccrualRulesTable } from 'components/table/accrual_rules/Table';

const AccrualRules = () => {
    return (
        <>
        <AccrualRulesTable />
        </>
    );
}

export { AccrualRules };